import Index from "../index";
import {StorySection} from "../../utils/storySection";
import {callEngine} from "../../server/_engine";
import {listOpeners, openerSlug} from "../../server/listings";


function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Opener pages are made on first request and kept until the next deploy, for the erotica openers the engine lists, at
// their exact address (a build can't reach the engine on Railway's private network)
export async function getStaticPaths() {
    return {paths: [], fallback: 'blocking'};
}

export async function getStaticProps(context: any) {
    const actualOpenerId = context.params.openerId.split('-')[0];
    const {value: openers} = await listOpeners();
    if (!openers.some((opener: any) => openerSlug(opener) === context.params.openerId)) {
        return {notFound: true, revalidate: 3600};
    }

    // get the contents for this openerId
    const inputPayload = {
        target: 'write',
        openerId: actualOpenerId, theme: 'erotica',
        openerOnly: true,
        newStory: true
    }
    // a dropped request is retried rather than failing the page
    var res2: any = {}
    for (let attempt = 0; attempt < 4 && !res2.data; attempt++) {
        if (attempt) await sleep(2000 * attempt)
        try {
            const data = await callEngine('write', {...inputPayload, userId: null})
            res2 = data ? {data} : {error: data}
        } catch (e) {
            res2 = {error: String(e)}
        }
    }
    console.log('result opener json received succesfully')
    console.log(res2)
    const res = res2.data;
    const title = res.title;

    // @ts-ignore
    const storySection = new StorySection(
        res.sectionId,
        res.text,
        res.imgUrl,
        [res.imgUrl],
        res.endOfStory,
        res.userText
    )
    return {
        props: {
            openerId: actualOpenerId,
            firstSection: storySection.toJSON(),
            title: title
        },
    }
}


export default function OpenerId(props: any) {
    return Index(props)
}